import { Component, inject, Input } from '@angular/core';
import { SelectButton, SelectButtonChangeEvent } from "primeng/selectbutton";
import { Tooltip } from "primeng/tooltip";
import { ThemeMode } from "../../models/theme-mode.enum";
import { FormsModule } from "@angular/forms";
import { LayoutService } from "../../service/layout.service";

@Component({
  selector: 'app-theme-select-button',
  imports: [
    SelectButton,
    Tooltip,
    FormsModule
  ],
  templateUrl: './theme-select-button.component.html',
  styleUrl: './theme-select-button.component.scss'
})
export class ThemeSelectButtonComponent {
  @Input() showLabel: boolean = true;
  protected layoutService = inject(LayoutService);
  currentThemeMode: ThemeMode = this.layoutService.themeMode();
  themeModeOptions = [
    {
      label: 'Light',
      value: ThemeMode.Light,
      icon: this.layoutService.getThemeModeIcon(ThemeMode.Light),
      tooltip: 'Light theme mode'
    },
    {
      label: 'Dark',
      value: ThemeMode.Dark,
      icon: this.layoutService.getThemeModeIcon(ThemeMode.Dark),
      tooltip: 'Dark theme mode'
    },
    {
      label: 'System',
      value: ThemeMode.System,
      icon: this.layoutService.getThemeModeIcon(ThemeMode.System),
      tooltip: 'Use this device\'s current theme mode'
    },
  ];

  onChange($event: SelectButtonChangeEvent) {
    this.layoutService.layoutConfig.update((state) => (
      {...state, themeMode: $event.value}
    ));
  }
}
